import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import EInvoice from "./E-Invoice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    height: "calc(100% - 154px)",
    overflowY: "auto"
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  },
  "& .MuiDialog-paper": {
    maxWidth: "1500px",
    width: "100%",
    height: "100%",
    maxHeight: "calc(100% - 154px)",
    display: "flex",
    flexDirection: "column"
  }
}));

export default function ShowEInvoice({
  open,
  setOpen,
  invoiceDataSrting,
  handleClose
}) {
  
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {"E-Invoice"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <EInvoice invoice={invoiceDataSrting} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>{" "}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
